import { MypageNovelNovelIdChapterChapterIdPlateGetInputModel } from "./GetInputModel"
import { MypageNovelNovelIdChapterChapterIdPlateGetResponse } from "./getResponse"
import { httpGet } from "../../../../../../../../libs/http/httpGet"

export const getMypageNovelNovelIdChapterChapterIdPlate = async (
  model: MypageNovelNovelIdChapterChapterIdPlateGetInputModel,
): Promise<MypageNovelNovelIdChapterChapterIdPlateGetResponse> => {
  return httpGet<MypageNovelNovelIdChapterChapterIdPlateGetResponse>(
    "/v1/mypage/novel/{novel_id}/chapter/{chapter_id}/plate",
    model,
  )
}
